export default "__VITE_ASSET__B8k9dqtL__"